import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload, faUsers } from '@fortawesome/free-solid-svg-icons'
import Dropdown from 'react-bootstrap/Dropdown'
import SodExport from 'duties/shared/Export'
import ShieldLogo from 'assets/Shield/White/ThirdLine Shield White.svg'

// Header actions for the Users#index page. Mirrors the Roles index
// `ActionsDropdown` pattern (primary shield button + dropdown driving
// controlled modals), exposing the user-list export and the compare-users
// grid.
function IndexActionsDropdown({ filterParams, onCompare }) {
  const [showExport, setShowExport] = useState(false)

  return (
    <React.Fragment>
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle variant="primary" id="users-actions-dropdown">
          <img
            src={ShieldLogo}
            alt=""
            className="me-2"
            style={{ height: '1.5em', verticalAlign: '-0.4em' }}
          />
          Actions
        </Dropdown.Toggle>
        <Dropdown.Menu align="end">
          <Dropdown.Item onClick={onCompare}>
            <FontAwesomeIcon
              icon={faUsers}
              fixedWidth
              className="me-2 text-muted"
            />
            Compare Users
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => setShowExport(true)}>
            <FontAwesomeIcon
              icon={faDownload}
              fixedWidth
              className="me-2 text-muted"
            />
            Export
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <SodExport
        params={filterParams}
        defaultName="Users"
        source="users"
        show={showExport}
        setShow={setShowExport}
        hideTrigger
      />
    </React.Fragment>
  )
}

IndexActionsDropdown.propTypes = {
  filterParams: PropTypes.object.isRequired,
  onCompare: PropTypes.func.isRequired
}

export default IndexActionsDropdown
